import React from 'react';
import ScrollAnimation from "../components/animations/ScrollAnimation";
import { useTranslation } from 'react-i18next';
import { useSectionT } from "../contexts/PageVariantContext";

const Team: React.FC = () => {
  const { t } = useTranslation();
  const sectionT = useSectionT();
  const teamMembers = t(sectionT('team.members'), { returnObjects: true }) as Array<{
    name: string;
    position: string;
    bio: string;
  }>;

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollAnimation>
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-poppins font-bold text-primary-900 mb-4">
              {t(sectionT('team.title'))}
            </h2>
            <div className="w-20 h-1 bg-accent-500 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {t(sectionT('team.subtitle'))}
            </p>
          </div>
        </ScrollAnimation>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 items-stretch">
          {teamMembers.map((member, index) => (
            <ScrollAnimation key={index} delay={index * 0.15} className="h-full">
              <div className="group flex h-full flex-col overflow-hidden rounded-xl bg-gray-50 shadow-md">
                <div className="relative shrink-0 overflow-hidden">
                  <div className="relative mx-auto mb-4 mt-4 h-32 w-32">
                    <div className="flex h-full w-full items-center justify-center overflow-hidden rounded-full bg-gray-100 p-8">
                      {index === 0 ? (
                        <svg className="w-24 h-24 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/>
                        </svg>
                      ) : index === 1 ? (
                        <svg className="w-20 h-20 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
                        </svg>
                      ) : index === 2 ? (
                        <svg className="w-20 h-20 text-purple-600" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
                        </svg>
                      ) : (
                        <svg className="w-20 h-20 text-orange-600" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
                        </svg>
                      )}
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-900 to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                    <div className="flex justify-center space-x-4">
                     
                    </div>
                  </div>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="mb-1 font-poppins text-xl font-semibold text-primary-900">
                    {member.name}
                  </h3>
                  <p className="mb-3 text-accent-500">{member.position}</p>
                  <p className="flex-1 text-gray-600">{member.bio}</p>
                </div>
              </div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
